import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as stageActions from '../../actions/stages';
import FormField from '../form/form-field';
import Select from '../form/select';
import LocalizedStrings from '../../localization/strings';

const singleEventWebsite = window.CARE_CONFIG.settings.single_event_website;


class DistanceSelection extends Component {

    componentWillMount() {
        if(this.props.onlyThisSeason){
            this.props.actions.fetchAllStages(window.CARE_CONFIG.settings.season.id)
        } else {
            this.props.actions.fetchAllStages();
        }
    }

    getStage(id) {
        const {stages} = this.props;
        let stageById;
        stages.forEach((stage) => {
            if (stage.id === id) {
                stageById = stage;
            }
        });
        return stageById;
    }

    render() {
        const {
            stages,
            stageField,
            distanceField = false,
            disableStageSelect = false
        } = this.props;
        this.distances = [];
        if (stageField.value) {
            const stage = this.getStage(stageField.value);
            if (stage) {
                this.distances = stage.distances;
            }
        }
        const renderStageSelect = !(singleEventWebsite && disableStageSelect);
        return (
            <div className="form-row-new">
                {renderStageSelect &&
                  <FormField label={LocalizedStrings.stage} name="stage" field={stageField}>
                      <Select clearable={false} options={stages} noResultsText={LocalizedStrings.noStages} placeholder={LocalizedStrings.stage} {...stageField} disabled={disableStageSelect} onChange={(event) => {
                          stageField.onChange(event.value);
                          if(stageField.value !== event.value){
                              distanceField.onChange(null);
                          }
                          if(this.props.onStageSelect){
                              this.props.onStageSelect(event.value);
                          }
                      }}/>

                  </FormField>}

                <FormField label={LocalizedStrings.distance} name="distance" field={distanceField}>
                    <Select {...distanceField} clearable={false} options={this.distances} noResultsText={LocalizedStrings.noDistances} placeholder={LocalizedStrings.distance} onChange={(event) => {
                        distanceField.onChange(event.value);
                    }}/>

                </FormField>
            </div>
        )
    }
}

export default connect(function(state) {
    return {stages: state.stage.availableStages.items}
}, function(dispatch) {
    return {
        actions: bindActionCreators(stageActions, dispatch)
    }
})(DistanceSelection);



// WEBPACK FOOTER //
// ./src/js/components/stage/distance-select.js